import { Component, OnInit, Input } from '@angular/core';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';

@Component({
  selector: 'app-mcommerce-current-trip-card',
  templateUrl: './mcommerce-current-trip-card.component.html',
  styleUrls: ['./mcommerce-current-trip-card.component.scss']
})
export class McommerceCurrentTripCardComponent implements OnInit {

  @Input() data;

  constructor() {
  }

  ngOnInit() {
  }

}
